import { render } from "./SeleccionMultiple.vue?vue&type=template&id=2266cf16"
import script from "./SeleccionMultiple.vue?vue&type=script&lang=js"
export * from "./SeleccionMultiple.vue?vue&type=script&lang=js"

import "./SeleccionMultiple.vue?vue&type=style&index=0&id=2266cf16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__